import { Link } from "react-router-dom";
import { Btn } from "@/components/public/Ui";
import { Seo } from "@/components/Seo";

export default function NotFound() {
  return (
    <>
      <Seo title="Page not found | Bahamas Kidney Association" noindex />
      <section data-testid="not-found-page" className="bka-container flex min-h-[65vh] flex-col justify-center py-20">
        <p className="bka-overline text-bka-emerald">Error 404</p>
        <h1 className="mt-4 max-w-xl font-display text-4xl font-bold leading-tight text-bka-navy sm:text-5xl">
          We couldn't find that page.
        </h1>
        <p className="mt-5 max-w-lg text-base text-bka-ink/75">
          The page may have moved or no longer exists. Try one of the links below, or reach out and we
          will point you in the right direction.
        </p>
        <div className="mt-9 flex flex-wrap gap-3">
          <Btn to="/" testId="not-found-home">
            Back to Home
          </Btn>
          <Btn to="/contact" variant="outline" testId="not-found-contact">
            Contact Us
          </Btn>
        </div>
        <div className="mt-12 flex flex-wrap gap-x-7 gap-y-3 text-sm font-semibold text-bka-emerald">
          {[
            ["Kidney Health", "/kidney-health"],
            ["Our Efforts", "/our-efforts"],
            ["Get Support", "/get-support"],
            ["Emerald Honours", "/emerald-honours"],
            ["Blog", "/blog"],
          ].map(([label, href]) => (
            <Link key={href} to={href} className="bka-link-underline">
              {label}
            </Link>
          ))}
        </div>
      </section>
    </>
  );
}
